import { dom } from "@omegagrid/core";
import { Form, FormContainer } from "@omegagrid/form";
import { ControlEvent } from "@omegagrid/form/dist/ui/controls/baseControl";
import { msg } from "@omegagrid/localize";
import rp, { SyncEditorAdapter, SyncEditorOptions, SyncTypes, SyncFormAdapter } from "@reporting/rp-app-host";
import { AccountingTreeAdapter } from "@reporting/rp-mf-accounting";
import { ObjectShare } from "@reporting/rp-types/core";
import { Project } from "@reporting/rp-types/ext";


export class ExtSyncEditorAdapter extends SyncEditorAdapter {

	async delete(idz: number) {
		await rp.ms('extensions').delete(`sync/objects/${idz}`);
	}

	async synchronize(ids?: number[]|null) {
		await rp.ms('extensions').get('sync', ids?.length ? { ids: ids.join(',') } : undefined);
	}

	async getEditFormComponent(idz: number): Promise<HTMLElement> {
		const component = dom.createElement<FormContainer>('og-form-container');
		component.adapter = new SyncFormAdapter(
			rp.ms('extensions'),
			[{
				key: 'only_share', // a custom view is either synchronized (copied) or shared (shown from here)
			}, {
				key: 'id_object',
				getSourceData: async () => {
					const projects = await rp.ms('extensions').get<Project[]>('projects');
					return projects.map(p => ({ k: p.id_custom_page.toString(), v: p.name }));
				},
			}, {
				key: 'accounting_share',
				// every company the user may see but this one, as a tree by groups
				getSourceData: () => new AccountingTreeAdapter({ excludedAccounting: rp.accountingProvider.a, byGroups: true }).getTree(),
			}, {
				key: 'id_share_object',
				getSourceData: async (accountingShare?: number) => {
					const list: { k: string; v: string }[] = [{ k: '', v: `<${msg('New')}>` }];
					if (!accountingShare) return list;
					const projects = await rp.ms('extensions').get<Project[]>(`sync/projects/${accountingShare}`);
					list.push(...projects.map(p => ({ k: p.id_custom_page.toString(), v: p.name })));
					return list;
				},
			}],
			idz
		);
		component.addEventListener('change', (e: ControlEvent<Form>) => {
			if (e.model.props.key === 'accounting_share') {
				(component.adapter as SyncFormAdapter).updateFormControls(component.forms[0]);
			}
		});
		return component;
	}

	async getObjects(): Promise<ObjectShare[]> {
		const objects = await rp.ms('extensions').get<ObjectShare[]>('sync/objects');
		return objects;
	}

	getOptions(): Partial<SyncEditorOptions> {
		return this.createOptions({
			syncType: SyncTypes.BOTH,
			selectableItems: true,
			columns: ['name', 'type', 'company', 'name_share', 'date_created', 'who_created'],
		});
	}

}
